import { useDispatch } from 'react-redux'
import { actions as userActions } from '../user/user.reducer'

const useAuthentication = () => {
    const dispatch = useDispatch()

    return {
        login: (email, password) => dispatch(userActions.loginAttemptWEP({ email, password })),
        authenticatedYes: () => dispatch(userActions.authenticatedYes()),
        authenticatedNo: () => dispatch(userActions.authenticatedNo()),
    }
}

export default useAuthentication
